import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { GetHTMLColour } from "./Common";

function ColourChip(props) {
    let width = "1rem";
    if (props.width) width = props.width;

    var divStyle = {
        display: "inline",
        borderRadius: "2px",
        border: "0px solid grey",
        paddingLeft: width,
        minWidth: width,
        minHeight: width,
        background: "#fff",
    };

    if (props.style) divStyle = { ...divStyle, ...props.style };

    let colour = props.colour;
    if (colour && GetHTMLColour(props.colour)[0] == "")
        colour = colour.replace(" TW", "").replace(" AM", "").replace(" LL", "").replace(" ST", "").replace(" HP", "");

    var htmlcolours = GetHTMLColour(colour);
    // 
    var top_bg_colour = GetHTMLColour(colour)[0];
    var bottom_bg2_colour = GetHTMLColour(colour)[1];
    var text_colour = htmlcolours[2];

    if (props.reverse) {
        let hold = bottom_bg2_colour;
        bottom_bg2_colour = top_bg_colour;
        top_bg_colour = hold;
    }

    if (top_bg_colour === bottom_bg2_colour) divStyle.background = top_bg_colour;
    else divStyle.background = "linear-gradient(135deg, " + top_bg_colour + " 50%, " + bottom_bg2_colour + " 50%)";

    if (top_bg_colour === "#FFFFFF" || bottom_bg2_colour === "#FFFFFF" || top_bg_colour === "#FCFCFC")
        divStyle.boxShadow = "0px 0px 2px rgb(0 0 0 / 20%)";
    // if (bg_colour === bg2_colour) $item_this.find(".color_sq").css("background", bg_colour);
    // else $item_this.find(".color_sq").css("background", "linear-gradient(135deg, " + bg_colour + " 50%, " + bg2_colour + " 50%)");

    return (
        <Tooltip
            title={props.tooltip_text ? props.tooltip_text : props.colour === undefined ? "Colour undefined" : colour}
            aria-label="add"
        >
            <div
                className={props.className}
                style={divStyle}
                onClick={(e) => (props.onClick ? props.onClick(e) : "")}
            ></div>
        </Tooltip>
    );
}

export default ColourChip;
